export function redirectToFoodCreatorSignIn() {
  // Clear the failed React/Convex subscription tree as well as changing routes.
  window.location.replace("/food-creator/sign-in?notDismissable=true");
}
